'use client';

import { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';
import LanguageSwitcher from './LanguageSwitcher';
const Icon = ({
  id,
  size = 15
}) => {
  const {
    t
  } = useTranslation();
  const icons = {
    social: <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    care: <><circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    research: <><path d="M11 19a8 8 0 100-16 8 8 0 000 16z" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M21 21l-4.35-4.35" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    benchmark: <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    smm: <><rect x="2" y="3" width="20" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M8 21h8M12 17v4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    publish: <><rect x="3" y="4" width="18" height="17" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M3 10h18M8 2v4M16 2v4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    location: <><path d="M12 22s-8-4.5-8-11.8A8 8 0 0112 2a8 8 0 018 8.2c0 7.3-8 11.8-8 11.8z" fill="none" stroke="currentColor" strokeWidth="1.8" /><circle cx="12" cy="10" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" /></>,
    command: <><rect x="2" y="3" width="20" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M8 21h8M12 17v4M2 10h20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    workflow: <><rect x="3" y="3" width="7" height="7" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" /><rect x="14" y="14" width="7" height="7" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M10 6.5h4a3 3 0 013 3V14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></>,
    integrations: <><circle cx="12" cy="5" r="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><circle cx="5" cy="19" r="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><circle cx="19" cy="19" r="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M12 7v4M12 11l-5 6M12 11l5 6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    bi: <><rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M3 9h18M9 21V9" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    forensic: <><path d="M12 22s-8-4.5-8-11.8A8 8 0 0112 2a8 8 0 018 8.2c0 7.3-8 11.8-8 11.8z" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M12 8v4l3 3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    marketing: <path d="M22 12h-4l-3 9L9 3l-3 9H2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    cx: <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    telecom: <><rect x="5" y="2" width="14" height="20" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><circle cx="12" cy="17" r="1" fill="currentColor" /></>,
    bank: <><path d="M2 10l10-7 10 7M4 10v8a1 1 0 001 1h14a1 1 0 001-1v-8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><rect x="9" y="14" width="6" height="5" fill="none" stroke="currentColor" strokeWidth="1.8" /></>,
    retail: <><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="1.8" /><path d="M16 10a4 4 0 01-8 0" fill="none" stroke="currentColor" strokeWidth="1.8" /></>,
    health: <path d="M22 12h-4l-3 9L9 3l-3 9H2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    auto: <><path d="M19 17H5a2 2 0 01-2-2V9a2 2 0 012-2h14a2 2 0 012 2v6a2 2 0 01-2 2z" fill="none" stroke="currentColor" strokeWidth="1.8" /><circle cx="7" cy="17" r="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><circle cx="17" cy="17" r="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M5 9l2-4h10l2 4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    travel: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81 19.79 19.79 0 010 .17A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />,
    fmcg: <><path d="M20 12V6H4v6M2 12h20M6 12v8M18 12v8M4 20h16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    edu: <><path d="M22 10v6M2 10l10-5 10 5-10 5-10-5z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><path d="M6 12v5c3 3 9 3 12 0v-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    tech: <><polyline points="16 18 22 12 16 6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><polyline points="8 6 2 12 8 18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></>,
    govt: <><path d="M2 10l10-7 10 7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><path d="M4 10v8a1 1 0 001 1h4v-4h6v4h4a1 1 0 001-1v-8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    energy: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    realestate: <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" fill="none" stroke="currentColor" strokeWidth="1.8" /><polyline points="9 22 9 12 15 12 15 22" fill="none" stroke="currentColor" strokeWidth="1.8" /></>,
    ai: <><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    cp: <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    ss: <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />,
    rg: <><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M8 10h.01M12 10h.01M16 10h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></>,
    iq: <><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></>,
    reports: <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><polyline points="14 2 14 8 20 8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    stories: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" fill="none" stroke="currentColor" strokeWidth="1.8" /><polyline points="22 6 12 13 2 6" fill="none" stroke="currentColor" strokeWidth="1.8" /></>,
    webinar: <><polygon points="23 7 16 12 23 17 23 7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><rect x="1" y="5" width="15" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /></>,
    podcast: <><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z" fill="none" stroke="currentColor" strokeWidth="1.8" /><path d="M19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    ebook: <><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></>,
    events: <><rect x="3" y="4" width="18" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" /><line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></>,
    blogs: <path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none">{icons[id] || null}</svg>;
};
const NAV = [{
  key: 'unified_cx',
  label: 'Unified CX',
  href: '/platform',
  sections: [{
    title: 'For Teams',
    items: [{
      icon: 'marketing',
      label: 'For Marketing Teams',
      href: '/solutions/for-marketing-teams',
      desc: 'Brand, campaigns & analytics'
    }, {
      icon: 'cx',
      label: 'For CX Teams',
      href: '/solutions/for-cx-teams',
      desc: 'Unified inbox & digital care'
    }]
  }, {
    title: 'Capabilities',
    cols: 2,
    items: [{
      icon: 'social',
      label: 'Social Intelligence',
      href: '/platform/social-intelligence',
      desc: '300+ sources, real-time'
    }, {
      icon: 'care',
      label: 'Holistic Digital Care',
      href: '/platform/holistic-digital-care',
      desc: 'Omnichannel care hub'
    }, {
      icon: 'research',
      label: 'Market Research',
      href: '/platform/market-research',
      desc: 'Consumer intelligence'
    }, {
      icon: 'benchmark',
      label: 'Competitive Benchmarking',
      href: '/platform/competitive-benchmarking',
      desc: 'Share of voice & trends'
    }, {
      icon: 'smm',
      label: 'Social Media Management',
      href: '/platform/social-media-management',
      desc: 'Publish, schedule, engage'
    }, {
      icon: 'publish',
      label: 'Publishing',
      href: '/platform/publishing',
      desc: 'One calendar, 7 channels'
    }, {
      icon: 'location',
      label: 'Location Intelligence',
      href: '/platform/location-intelligence',
      desc: 'Geo insights at city level'
    }, {
      icon: 'command',
      label: 'Command Centre',
      href: '/platform/command-centre',
      desc: 'Live brand war room'
    }, {
      icon: 'workflow',
      label: 'Workflow Automation',
      href: '/platform/workflow-automation',
      desc: 'Alert, moderate & reply on autopilot'
    }, {
      icon: 'integrations',
      label: 'Integrations',
      href: '/platform/integrations',
      desc: '57+ CRM & helpdesk tools'
    }]
  }, {
    title: 'Solutions',
    items: [{
      icon: 'bi',
      label: 'Business Intelligence',
      href: '/solutions/business-intelligence',
      desc: 'Boardroom-ready analytics'
    }, {
      icon: 'forensic',
      label: 'Forensic Audit',
      href: '/solutions/forensic-audit',
      desc: 'Deep compliance insights'
    }]
  }],
  featured: {
    tagline: 'Shift from insight to instinct, with AI at the core\u2122',
    cta: 'Book a demo',
    href: '#book-demo'
  }
}, {
  key: 'industries',
  label: 'Industries',
  href: '/industries',
  sections: [{
    title: 'Industries',
    cols: 2,
    items: [{
      icon: 'telecom',
      label: 'Telecom',
      href: '/industries/telecom',
      desc: 'Churn prediction & social'
    }, {
      icon: 'bank',
      label: 'Banking & Finance',
      href: '/industries/bfsi',
      desc: 'Trust & compliance CX'
    }, {
      icon: 'retail',
      label: 'Retail & E-commerce',
      href: '/industries/retail-brands',
      desc: 'Delivery, reviews & festive-sale CX'
    }, {
      icon: 'health',
      label: 'Healthcare',
      href: '/industries/healthcare',
      desc: 'Patient sentiment monitoring'
    }, {
      icon: 'auto',
      label: 'Automobile',
      href: '/industries/mobility',
      desc: 'Dealership to brand CX'
    }, {
      icon: 'travel',
      label: 'Travel & Hospitality',
      href: '/industries/travel-and-hospitality',
      desc: 'Review & service recovery'
    }, {
      icon: 'fmcg',
      label: 'FMCG',
      href: '/industries/fmcg',
      desc: 'Multi-SKU campaign tracking'
    }, {
      icon: 'edu',
      label: 'Education',
      href: '/industries/education',
      desc: 'Institutional reputation'
    }, {
      icon: 'tech',
      label: 'Technology',
      href: '/industries/technology',
      desc: 'Product feedback loops'
    }, {
      icon: 'govt',
      label: 'Government & Public',
      href: '/industries/government-public-sector',
      desc: 'Civic intelligence'
    }, {
      icon: 'energy',
      label: 'Energy Utilities',
      href: '/industries/energy-utilities',
      desc: 'Outage & billing chatter'
    }, {
      icon: 'realestate',
      label: 'Real Estate',
      href: '/industries/real-estate',
      desc: 'Buyer trust & reputation'
    }]
  }]
}, {
  key: 'ai_core',
  label: 'AI at the Core\u2122',
  href: '/ai-stack',
  sections: [{
    title: 'Our AI Stack',
    items: [{
      icon: 'ai',
      label: 'Locobuzz AI',
      href: '/ai-stack',
      desc: 'The full AI platform overview'
    }, {
      icon: 'cp',
      label: 'ContextualPulse\u2122',
      href: '/ai-stack/contextualpulse',
      desc: 'Emotion & intent detection'
    }, {
      icon: 'ss',
      label: 'SignalSense\u2122',
      href: '/ai-stack/signalsense',
      desc: 'Trend & crisis early warning'
    }, {
      icon: 'rg',
      label: 'ResponseGenie\u2122',
      href: '/ai-stack/responsegenie',
      desc: 'On-brand AI reply generation'
    }, {
      icon: 'iq',
      label: 'AgentIQ\u2122',
      href: '/ai-stack/agentiq',
      desc: 'Real-time agent coaching'
    }]
  }],
  featured: {
    tagline: 'Four AI engines. One unified CX intelligence core.',
    cta: 'Explore AI Stack',
    href: '/ai-stack'
  }
}, {
  key: 'pricing',
  label: 'Pricing',
  href: '/pricing',
  plain: true
}, {
  key: 'resources',
  label: 'Resources',
  href: '/resources',
  sections: [{
    title: 'Resources',
    items: [{
      icon: 'reports',
      label: 'Industry Reports',
      href: '/resources/industry-reports',
      desc: 'Benchmarks & research'
    }, {
      icon: 'stories',
      label: 'Customer Stories',
      href: '/resources/customer-stories',
      desc: 'Real brand case studies'
    }, {
      icon: 'webinar',
      label: 'Webinars',
      href: '/resources/webinars',
      desc: 'Expert-led live sessions'
    }, {
      icon: 'podcast',
      label: 'Podcasts',
      href: '/resources/podcasts',
      desc: 'VoCX \u2014 voice of CX leaders'
    }, {
      icon: 'blogs',
      label: 'Blogs',
      href: 'https://locobuzz.com/blogs/',
      desc: 'Guides & thought leadership'
    }, {
      icon: 'ebook',
      label: 'Guides & Ebooks',
      href: '/resources/guides-and-ebooks',
      desc: 'Playbooks & free downloads'
    }, {
      icon: 'events',
      label: 'Events',
      href: '/resources/events',
      desc: 'Conferences & roundtables'
    }]
  }]
}];
const DROP_W = {
  unified_cx: 820,
  industries: 460,
  ai_core: 440,
  resources: 360
};
export default function Navbar() {
  const {
    t
  } = useTranslation();
  const [open, setOpen] = useState(null);
  const [mob, setMob] = useState(false);
  const [mobExpand, setMobExpand] = useState(null); // which mobile submenu is open
  const [scrolled, setScrolled] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', fn, {
      passive: true
    });
    fn();
    return () => window.removeEventListener('scroll', fn);
  }, []);
  const enter = k => {
    clearTimeout(timer.current);
    setOpen(k);
  };
  const leave = () => {
    timer.current = setTimeout(() => setOpen(null), 160);
  };
  return <>
      <header className={`zd-nav${scrolled ? ' zd-nav--scrolled' : ''}`}>
        <div className="zd-nav__pill">
        <div className="zd-nav__inner" onMouseLeave={leave}>

          <Link href="/" className="zd-nav__logo">
            <img src="/locobuzz-logo.svg" alt={t("nav.locobuzz")} height={26} decoding="async" />
          </Link>

          <nav className="zd-nav__links">
            {NAV.map(item => <div key={item.key} className="zd-nav__item" onMouseEnter={() => !item.plain && enter(item.key)}>
                <Link href={item.href} onClick={() => setOpen(null)} className={`zd-nav__link${open === item.key ? ' zd-nav__link--open' : ''}`}>
                  {item.label}
                  {!item.plain && <svg className="zd-nav__chevron" width="10" height="10" viewBox="0 0 12 12" fill="none">
                      <polyline points="2,4 6,8 10,4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>}
                </Link>

                {!item.plain && <div className={`zd-drop zd-drop--${item.key}${open === item.key ? ' zd-drop--open' : ''}`} style={{
                minWidth: DROP_W[item.key] || 340
              }} onMouseEnter={() => enter(item.key)}>
                    <div className="zd-drop__sections">
                      {item.sections.map(sec => <div key={sec.title} className="zd-drop__section">
                          <p className="zd-drop__section-title">{sec.title}</p>
                          <div className={`zd-drop__links${sec.cols === 2 ? ' zd-drop__links--2col' : ''}`}>
                            {sec.items.map(link => link.href.startsWith('http') ? <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className="zd-drop__link" onClick={() => setOpen(null)}>
                                    <span className="zd-drop__link-icon"><Icon id={link.icon} size={14} /></span>
                                    <span>
                                      <span className="zd-drop__link-label">{link.label}</span>
                                    </span>
                                  </a> : <Link key={link.href} href={link.href} className="zd-drop__link" onClick={() => setOpen(null)}>
                                    <span className="zd-drop__link-icon"><Icon id={link.icon} size={14} /></span>
                                    <span>
                                      <span className="zd-drop__link-label">{link.label}</span>
                                    </span>
                                  </Link>)}
                          </div>
                        </div>)}
                    </div>
                    {item.featured && <div className="zd-drop__featured">
                        <p className="zd-drop__featured-quote">"{item.featured.tagline}"</p>
                        <Link href={item.featured.href} onClick={() => setOpen(null)} className="zd-drop__featured-cta">
                          {item.featured.cta} →
                        </Link>
                      </div>}
                  </div>}
              </div>)}
          </nav>

          <div className="zd-nav__actions">
            <LanguageSwitcher variant="navbar" />
            <a href="https://cx.locobuzz.com/login" target="_blank" rel="noopener noreferrer" className="zd-nav__login">{t("nav.login")}</a>
            <a href="#book-demo" className="zd-nav__cta">
              {t("nav.book_demo")}
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>

          <button className="zd-nav__ham" onClick={() => setMob(m => !m)} aria-label={t("nav.menu")}>
            <span style={{
              transform: mob ? 'rotate(45deg) translateY(6px)' : 'none',
              transition: 'all 0.2s',
              display: 'block',
              height: 2,
              width: 22,
              background: '#374151',
              borderRadius: 2,
              marginBottom: 4
            }} />
            <span style={{
              opacity: mob ? 0 : 1,
              transition: 'all 0.2s',
              display: 'block',
              height: 2,
              width: 22,
              background: '#374151',
              borderRadius: 2,
              marginBottom: 4
            }} />
            <span style={{
              transform: mob ? 'rotate(-45deg) translateY(-6px)' : 'none',
              transition: 'all 0.2s',
              display: 'block',
              height: 2,
              width: 22,
              background: '#374151',
              borderRadius: 2
            }} />
          </button>
        </div>
        </div>
      </header>

      {mob && <div className="zd-mob-nav">
          {NAV.map(item => {
        const {
          t
        } = useTranslation();
        const isOpen = mobExpand === item.key;
        // Plain links (no submenu) — direct navigation
        if (item.plain || !item.sections) {
          return <Link key={item.key} href={item.href} className="zd-mob-nav__link" onClick={() => setMob(false)}>
                  {item.label}
                </Link>;
        }
        // Items with submenus — tap to expand
        return <div key={item.key} className="zd-mob-nav__group">
                <button type="button" className="zd-mob-nav__link zd-mob-nav__toggle" onClick={() => setMobExpand(isOpen ? null : item.key)} aria-expanded={isOpen}>
                  <span>{item.label}</span>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{
              transform: isOpen ? 'rotate(180deg)' : 'none',
              transition: 'transform 0.18s'
            }}>
                    <polyline points="2,4 6,8 10,4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                </button>
                {isOpen && <div className="zd-mob-nav__sub">
                    <Link href={item.href} className="zd-mob-nav__sublink zd-mob-nav__sublink--all" onClick={() => setMob(false)}>
                      {t("nav.all")} {item.label} →
                    </Link>
                    {item.sections.flatMap(sec => sec.items).map(link => link.href.startsWith('http') ? <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className="zd-mob-nav__sublink" onClick={() => setMob(false)}>
                          <Icon id={link.icon} size={14} />
                          <span>{link.label}</span>
                        </a> : <Link key={link.href} href={link.href} className="zd-mob-nav__sublink" onClick={() => setMob(false)}>
                          <Icon id={link.icon} size={14} />
                          <span>{link.label}</span>
                        </Link>)}
                  </div>}
              </div>;
      })}
          <div className="zd-mob-nav__footer">
            <LanguageSwitcher variant="navbar" />
            <a href="https://cx.locobuzz.com/login" target="_blank" rel="noopener noreferrer" className="zd-mob-nav__link" onClick={() => setMob(false)}>{t("nav.login")}</a>
            <a href="#book-demo" className="zd-nav__cta" style={{
          width: '100%',
          justifyContent: 'center'
        }} onClick={() => setMob(false)}>{t("nav.book_a_demo")}</a>
          </div>
        </div>}

      <style jsx global>{`
        .zd-mob-nav { overflow-y: auto; -webkit-overflow-scrolling: touch; }
        .zd-mob-nav__group { border-bottom: 1px solid rgba(15,23,42,0.06); }
        .zd-mob-nav__toggle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          background: transparent;
          border: none;
          padding: 14px 0;
          font: inherit;
          color: inherit;
          cursor: pointer;
          text-align: left;
        }
        .zd-mob-nav__sub {
          padding: 4px 0 14px 12px;
          display: flex;
          flex-direction: column;
          gap: 2px;
          border-left: 2px solid rgba(0,152,255,0.18);
          margin-left: 4px;
        }
        .zd-mob-nav__sublink {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 12px;
          color: #475569;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          border-radius: 8px;
          transition: background 0.15s, color 0.15s;
        }
        .zd-mob-nav__sublink:hover,
        .zd-mob-nav__sublink:active { background: rgba(0,152,255,0.06); color: #0098FF; }
        .zd-mob-nav__sublink--all { font-weight: 700; color: #0098FF; }
      `}</style>
    </>;
}